module.exports = __webpack_public_path__ + "img/title.59055db2.png";